import React, { useContext } from 'react'
import { StickyContainer, Sticky } from 'react-sticky-17'
import CustomNavContext from '@/context/customNavContext'
import { thirdPackagePx2px } from '@/utils/styleUtils'
import { isCanHiddenNav } from '@/utils/appUtils/getDevice'

export function StickyWrapper(props: any) {
  const { children, customTopOffset,...rest } = props
  const { statusBarHeight, hideNavigation, statusBarHeightPx } = useContext(CustomNavContext)
  const top = (isCanHiddenNav() && hideNavigation) ? statusBarHeightPx : 0
  const topOffset =  customTopOffset
                      ? customTopOffset
                      : top
                        ? 0 - top
                        : 0
  return (
    <Sticky
      topOffset={thirdPackagePx2px(topOffset)}
      {...rest}
    >
      {(p) => {
        const { style } = p
        const nextProps = { ...p }
        if (top && style.top <= top) {
          nextProps.style = {
            ...style,
            top: statusBarHeight,
          }
        }
        return children(nextProps)
      }}
    </Sticky>
  )
}

export { StickyContainer }
